import { render, staticRenderFns } from "./MultiScreen.vue?vue&type=template&id=1e2be277"
import script from "./MultiScreen.vue?vue&type=script&lang=js"
export * from "./MultiScreen.vue?vue&type=script&lang=js"
import style0 from "./MultiScreen.vue?vue&type=style&index=0&id=1e2be277&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports